import { render, staticRenderFns } from "./PendingInvoicesAside.vue?vue&type=template&id=3407f205&scoped=true&"
import script from "./PendingInvoicesAside.vue?vue&type=script&lang=js&"
export * from "./PendingInvoicesAside.vue?vue&type=script&lang=js&"
import style0 from "./PendingInvoicesAside.vue?vue&type=style&index=0&id=3407f205&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3407f205",
  null
  
)

export default component.exports